import {AGENT_CONSTS} from "../constants/agentConsts";
import {_urlAgent, _urlExtension, request} from "../api";
import {UTIL_CONSTS} from "../constants/utilConsts";


export const GetAgentsService = () => {
    let requestData = {
        url: `${_urlAgent}/`,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then(async (res) => {
                await dispatch({
                    type: AGENT_CONSTS.GET_AGENTS_LIST,
                    payload: res?.data || {}
                })
            })
    };
};

export const GetTemplatesAgentsService = (lng) => {
    let requestData = {
        url: `${_urlAgent}/templates/list?language=${lng}`,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then(async (res) => {
                await dispatch({
                    type: AGENT_CONSTS.GET_TEMPLATES_AGENT,
                    payload: res?.data?.templates || []
                })
            })
    };
};


export const CreateAgentService = (data) => {
    const requestData = {
        url: `${_urlAgent}/`,
        method: "POST",
        data
    };
    return request(requestData)
        .then(async (res) => {
            return res?.data
        })
};


export const DeleteAgentService = (id) => {
    const requestData = {
        url: `${_urlAgent}/${id}`,
        method: "DELETE",
    };
    return request(requestData)
        .then(async (res) => {
            return res?.data
        })
};


export const UpdateAgentService = (id, data) => {
    const requestData = {
        url: `${_urlAgent}/${id}`,
        method: "PATCH",
        data
    };
    return request(requestData)
        .then(async (res) => {
            return res?.data
        })
};

export const UpdateLanguageAgentService = (data) => {
    return dispatch => {
        dispatch({
            type: AGENT_CONSTS.UPDATE_LANGUAGE,
            payload: data
        })
    }
};